import isValidMobileNumber from '../../../features/auth/utils/isValidMobileNumber'
import { emailValidation } from '../../../utils/validations'

export default function isLoginFormValid({
	mobileNumber,
	email,
	countryPhoneCode,
	loginPassword,
	// ...rest
}) {
	// console.log({ mobileNumber, email, countryPhoneCode, loginPassword, rest })
	return (
		((email && emailValidation(email)) ||
			(mobileNumber &&
				isValidMobileNumber(`${countryPhoneCode}${mobileNumber}`))) &&
		(loginPassword || '').length > 0
	)
}
